import { useQuery } from '@tanstack/react-query';
import { brgsApi } from '../api/brgs';
import { useAuth } from '../auth/useAuth';
import { BrgListItemDto } from '../types';

/**
 * Fetches the BRGs assigned to the current user as a lead.
 * For admins: returns all BRGs
 * For leads: returns only BRGs where they are assigned as Lead, Co-Lead, Community Lead, etc.
 */
export function useUserAssignedBrgs() {
  const { roles, name } = useAuth();

  return useQuery<BrgListItemDto[], Error>({
    queryKey: ['userAssignedBrgs', name, roles],
    queryFn: async () => {
      // The backend already filters BRGs by role:
      // - Admins see all BRGs
      // - Leads see only BRGs where they have a lead role in BRG_Memberships
      return brgsApi.list();
    },
    enabled: !!name,
  });
}
